module.exports = __webpack_public_path__ + "static/img/613_phase_function_Paper_PointsHejduk_Prediction.a86b059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/613_phase_function_Paper_PointsHejduk_Prediction.png
// module id = udV3
// module chunks = 0